import DisciplineModel from './DisciplineModel'

export default class CategoryModel {
  constructor (data) {
    this.id = data.id
    this.name = data.name
    this.disciplines = data.disciplines ? data.disciplines.map(discipline => new DisciplineModel(discipline)) : null
  }
}
